import { render, staticRenderFns } from "./memberData.vue?vue&type=template&id=6f54e575&scoped=true"
import script from "./memberData.vue?vue&type=script&lang=js"
export * from "./memberData.vue?vue&type=script&lang=js"
import style0 from "./memberData.vue?vue&type=style&index=0&id=6f54e575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54e575",
  null
  
)

export default component.exports